var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlus2Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11200",
    "data-name": "Group 11200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.855,
    height: 13.816,
    viewBox: "0 0 13.855 13.816",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4105",
    "data-name": "Rectangle 4105",
    width: 13.855,
    height: 13.816,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11199",
    "data-name": "Group 11199",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M6.24,107.643v1.382H.8a.873.873,0,0,1-.467-.114A.686.686,0,0,1,.25,107.8a.857.857,0,0,1,.487-.152c.036,0,.072,0,.109,0Z",
    transform: "translate(0 -101.425)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    d: "M137.579,108.979a1.155,1.155,0,0,1-.348.061q-2.652.005-5.3,0h-.145V107.66h.149q2.652,0,5.3,0a1.221,1.221,0,0,1,.278.032.665.665,0,0,1,.51.6.678.678,0,0,1-.445.685",
    transform: "translate(-124.171 -101.442)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    d: "M109.429,6.068v6.957a.97.97,0,0,1-.069.38.667.667,0,0,1-1.279-.189c-.013-.129-.02-.258-.02-.387q0-2.386,0-4.77V6q0-2.616,0-5.232a.739.739,0,0,1,.246-.6.636.636,0,0,1,.667-.122.641.641,0,0,1,.434.546,2.836,2.836,0,0,1,.021.377q0,2.549,0,5.1",
    transform: "translate(-101.819 0)",
    fill: "#0094d1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus2Icon);
export default __webpack_public_path__ + "static/media/plus-2-icon.51216f4fe8fbebcc43bb9ea17559cb6d.svg";
export { ForwardRef as ReactComponent };